var _rect, _g, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 43.5,
    height: 43.5,
    rx: 3.75,
    fill: "white",
    stroke: "#E2E2E2",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_292_260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2673 24.4791C21.72 24.8439 21.0842 25.0368 20.4287 25.0368C19.7733 25.0368 19.1375 24.8439 18.5902 24.4791L9.57519 18.4689C9.52543 18.4356 9.47658 18.401 9.42871 18.365V28.2133C9.42871 29.3425 10.345 30.2386 11.454 30.2386H29.4034C30.5326 30.2386 31.4287 29.3223 31.4287 28.2133V18.365C31.3807 18.401 31.3318 18.4357 31.2819 18.4691L22.2673 24.4791Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2902 17.3958L19.3052 23.406C19.6465 23.6335 20.0376 23.7473 20.4287 23.7473C20.8198 23.7473 21.211 23.6335 21.5522 23.406L30.5672 17.3958C31.1067 17.0364 31.4287 16.4348 31.4287 15.7855C31.4287 14.6692 30.5205 13.761 29.4042 13.761H11.4533C10.3369 13.761 9.42871 14.6692 9.42871 15.7866C9.42838 16.1051 9.50687 16.4187 9.6572 16.6995C9.80752 16.9803 10.025 17.2195 10.2902 17.3958Z",
    fill: "#313131"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.0004,
    cy: 12.5707,
    r: 4.71429,
    fill: "#FF5151"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_292_260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(9.42871 10.9995)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.e55fcf4318305fd0ac4773e84eb6c31e.svg";
export { ForwardRef as ReactComponent };